import type { IconComponent } from '@consta/icons/Icon'
import type { Prettify } from 'common/types'
import type { ComponentProps, FC } from 'react'

import css from '../List.css'

type IconComponentProps = Omit<ComponentProps<IconComponent>, 'as'>

type ListItemProps = Prettify<
  IconComponentProps & {
    icon: IconComponent
  }
>

export const ListItemIcon: FC<ListItemProps> = ({ icon: Icon, ...iconProps }) => {
  return <Icon className={css.icon} {...iconProps} as="span" />
}
